import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import img from "../../../Assets/UserSide/com.png";
import img1 from "../../../Assets/UserSide/people.png";
import img2 from "../../../Assets/Images/profileimg3.jpeg";
import img3 from "../../../Assets/Images/image.png";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
function FeedbackCard({ text, name, role, imageUrl, animation }) {
  return (
    <div
      className="bg-blue-900 text-white p-6 md:p-8 rounded-lg shadow-lg flex flex-col"
      data-aos={animation} // AOS animation dynamically passed
    >
      <div className="text-center mb-4">
        <div className="w-12 h-1 bg-gray-300 mx-auto"></div>
      </div>
      <p className="text-base md:text-lg mb-6">{text}</p>
      <div className="flex items-center">
        <img
          src={imageUrl}
          alt={`Profile picture of ${name}`}
          className="w-12 h-12 rounded-full mr-4"
        />
        <div>
          <p className="font-semibold">{name}</p>
          <p className="text-gray-300 text-sm">{role}</p>
        </div>
        <div className="ml-auto">
          <img src={img} alt="images" />
        </div>
      </div>
    </div>
  );
}

const Feedback = () => {
  const feedbacks = [
    {
      text: "I absolutely loved the vibe here. Great community and fantastic facilities. Highly recommend it to anyone traveling through the.",
      name: "Aditi Verma",
      role: "Traveler",
      imageUrl: img2,
    },
    {
      text: "Amazing experience! The staff was incredibly accommodating, and the rooms were clean and comfortable. I would definitely come back.",
      name: "Rajesh Mehta",
      role: "Tourist",
      imageUrl: img1,
    },
    {
      text: "I absolutely loved the vibe here. Great community and fantastic facilities. Highly recommend it to anyone traveling through the.",
      name: "Sanjay Kapoor",
      role: "Backpacker",
      imageUrl: img3,
    },
    {
      text: "Amazing experience! The staff was incredibly accommodating, and the rooms were clean and comfortable. I would definitely come back.",
      name: "Rajesh Mehta",
      role: "Tourist",
      imageUrl: img1,
    },
    {
      text: "I absolutely loved the vibe here. Great community and fantastic facilities. Highly recommend it to anyone traveling through the.",
      name: "Sanjay Kapoor",
      role: "Backpacker",
      imageUrl: img3,
    },
  ];

  // List of AOS animations
  const animations = [
    "fade-up",
    "fade-down",
    "zoom-in",
    "zoom-out",
    "flip-left",
    "flip-right",
  ];

  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <div className="px-4 md:px-16 py-8">
      <div className="sm:text-center text-start " data-aos="fade-down">
        <h1
          className="text-3xl md:text-4xl font-semibold"
          style={{ fontFamily: '"Reem Kufi", sans-serif' }}
        >
          Google’s Best Rated Hostel Accommodation in Bhubaneswar
        </h1>
        <p className="mt-4 w-full xl:w-[70%] sm:px-20 px-0 sm:mx-auto mx-0 text-gray-600 my-12">
          In publishing and graphic design, Lorem ipsum is a placeholder text
          commonly used to demonstrate the visual form of a document or a
          typeface without relying on meaningful content. 
        </p>
      </div>
      <Swiper
        modules={[Navigation, Pagination, Autoplay]}
        spaceBetween={30}
        navigation
        pagination={{ clickable: true }}
        autoplay={{ delay: 3000, disableOnInteraction: false }}
        loop={true}
        breakpoints={{
          470: { slidesPerView: 1 }, // Small screens (1 card)
          768: { slidesPerView: 2 }, // Medium screens (2 cards)
          1024: { slidesPerView: 3 }, // Large screens (3 cards)
        }}
        // className="grid grid-cols-1 lg:grid-cols-3 gap-6 md:gap-8"
      >
        {feedbacks.map((feedback, index) => (
          <SwiperSlide key={index}>
            <FeedbackCard
              text={feedback.text}
              name={feedback.name}
              role={feedback.role}
              imageUrl={feedback.imageUrl}
              animation={animations[index % animations.length]} // Assign animation dynamically
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default Feedback;
